<script>
import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"

</script>
<div class="pageContainer">
  <StandardHeader />
  <div class="mainContentSection" style="min-width:300px">

	<p class="message">Sorry we can't seem to find this board <span class="svelte-1ndkr0s" style="font-size: 26px;">&nbsp;🥹</span> </p>

	<p class="">Please check with the board owner for the correct url.</p>

  </div>
  <StandardFooter/>
</div>

<style>
.pageContainer{min-height:100vh;  display: flex; flex-direction: column; }
.mainContentSection {min-height: calc(100vh - 200px);  display: flex; flex-direction: column; align-self: center; }
.message {font-size: 1.25rem; color: var(--blue); font-weight: bold; margin-top: 100px}
</style>